import { graphql } from "gql";

const EDIT_MESSAGE_THREAD_REMIND_TIME_MUTATION = graphql(`
  mutation EditMessageThreadRemindTime($id: ID!, $remindTime: Instant!) {
    editMessageThread(id: $id, input: { remindTime: $remindTime }) {
      id
      remindTime
      isInbox
    }
  }
`);

export default EDIT_MESSAGE_THREAD_REMIND_TIME_MUTATION;
